import { TypedUseSelectorHook, useSelector as useUntypedSelector } from 'react-redux';

import { YammerI18nState } from '../state/types';

export const useSelector: TypedUseSelectorHook<YammerI18nState> = useUntypedSelector;
